import { render } from "./ConvertorSettingsModal.vue?vue&type=template&id=21c788dd"
import script from "./ConvertorSettingsModal.vue?vue&type=script&lang=js"
export * from "./ConvertorSettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script